import { BOOKING_STATUSES } from '@src/types/Booking';
export default function updateBulkAssignmentState(requests, update) {
    const requestIds = new Set(update.request_ids);
    const confirmedBookingRefs = new Set(update.operation === 'assign' ? update.confirmedBookingRefs || [] : []);
    requests.forEach((request) => {
        if (requestIds.has(request.id || '')) {
            request.assignee = update.operation === 'assign' ? update.assignee : null;
        }
        if (request.booking_ref && confirmedBookingRefs.has(request.booking_ref)) {
            request.booking_status = BOOKING_STATUSES.CONFIRMED;
        }
    });
}
